import React, { useState } from 'react';
import { Send, Mail, User, MessageSquare } from 'lucide-react';
import { PageHero, Card, Button } from '../components/ui';

export default function ContactPage() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('loading');

        try {
            const response = await fetch('/api/send-email', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name, email, message }),
            });

            if (response.ok) {
                setStatus('success');
                setName('');
                setEmail('');
                setMessage('');
            } else {
                const data = await response.json();
                console.error(data.error);
                setStatus('error');
            }
        } catch (error) {
            console.error('An error occurred:', error);
            setStatus('error');
        }
    };

    const inputClasses = "w-full p-3 border border-slate-300 dark:border-slate-600 rounded-xl text-base bg-white dark:bg-slate-700 text-slate-900 dark:text-white placeholder-slate-400 dark:placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all";
    const labelClasses = "block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5";

    return (
        <div className="bg-slate-50 dark:bg-slate-900 min-h-screen transition-colors duration-200">
            <PageHero
                title="Contact Us"
                subtitle="We'd love to hear from you. Send us any questions or feedback below."
            />

            <div className="container mx-auto px-4 -mt-16 relative z-10 pb-16 max-w-2xl">
                <Card>
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label htmlFor="name" className={labelClasses}>
                                <User size={14} className="inline mr-1.5 text-brand-600 dark:text-brand-400" />
                                Full Name
                            </label>
                            <input
                                type="text"
                                name="name"
                                id="name"
                                className={inputClasses}
                                placeholder="Jane Doe"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </div>
                        <div>
                            <label htmlFor="email" className={labelClasses}>
                                <Mail size={14} className="inline mr-1.5 text-brand-600 dark:text-brand-400" />
                                Email
                            </label>
                            <input
                                type="email"
                                name="email"
                                id="email"
                                className={inputClasses}
                                placeholder="you@example.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <div>
                            <label htmlFor="message" className={labelClasses}>
                                <MessageSquare size={14} className="inline mr-1.5 text-brand-600 dark:text-brand-400" />
                                Message
                            </label>
                            <textarea
                                id="message"
                                name="message"
                                rows="5"
                                className={inputClasses}
                                placeholder="How can we help?"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                required
                            ></textarea>
                        </div>
                        <div>
                            <Button type="submit" fullWidth size="lg" icon={Send} disabled={status === 'loading'}>
                                {status === 'loading' ? 'Sending...' : 'Send Message'}
                            </Button>
                            {status === 'success' && (
                                <div className="mt-4 p-3 bg-brand-50 dark:bg-brand-900/20 text-brand-700 dark:text-brand-400 rounded-lg text-center text-sm font-medium">
                                    Message sent successfully! Thank you.
                                </div>
                            )}
                            {status === 'error' && (
                                <div className="mt-4 p-3 bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 rounded-lg text-center text-sm font-medium">
                                    Something went wrong. Please try again later.
                                </div>
                            )}
                        </div>
                    </form>
                </Card>
            </div>
        </div>
    );
}
